import React, { useState } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAction } from "reduxsauce";

import { Creators as AllCreators } from "../../../../actions";
import { ItemLabel } from "../../../../App/Common/Components/FormComponents";
import { SectionTitle } from "../../../../App/Common/Styles/containers";
import { IState } from "../../../../App/reducer";
import { modifyCoursePlayerPatch, patchPayloadCreator } from "../../../course-author/helpers/patches/creators";
import {
  CoursePlayer,
  DefaultWide,
  FullResponsiveWide,
  IFullCourse,
  PercentageWide,
  SaltWide,
} from "../../../course-author/types";
import { CheckBox, FormContainer } from "../FormElements";

const Creators = (AllCreators as any).App.CourseAuthor;

export interface IEditCoursePlayerDispatchProps {
  selectCoursePlayer: (value: CoursePlayer) => void;
}

export interface IEditCoursePlayerOwnProps {
  course: IFullCourse;
  courseId: string;
  userId: string;
}
export interface IEditCoursePlayerState {
  selected: CoursePlayer;
}

export type IEditCoursePlayerProps = IEditCoursePlayerState &
  IEditCoursePlayerOwnProps &
  IEditCoursePlayerDispatchProps;

const DEFAULT_PERCENTAGE = 90;

export const EditCoursePlayer: React.FC<IEditCoursePlayerProps> = props => {
  const { selected } = props;
  if (!selected) return null;
  const isPercentageWide = typeof selected === "object" && "percentage" in selected;
  const isSaltWide = selected === SaltWide;
  const isFullResponsiveWide = selected === FullResponsiveWide;
  const isDefaultWide = selected === DefaultWide;

  const [percentage, setPercentage] = useState(isPercentageWide ? (selected as PercentageWide).percentage : 90);

  const onSelectPlayer = (value: CoursePlayer) => () => props.selectCoursePlayer(value);

  const onPercentageInputCheck = (_: React.ChangeEvent<HTMLInputElement>) => {
    onSelectPlayer({ percentage: DEFAULT_PERCENTAGE })();
    setPercentage(DEFAULT_PERCENTAGE);
  };

  return (
    <>
      <SectionTitle>Course Player</SectionTitle>
      <FormContainer>
        {isDefaultWide && (
          <ItemLabel>
            <CheckBox
              type="radio"
              name="course-player-radio"
              value={DefaultWide}
              checked={isDefaultWide}
              onChange={onSelectPlayer(DefaultWide)}
            />
            Narrow
          </ItemLabel>
        )}
        <ItemLabel>
          <CheckBox
            type="radio"
            name="course-player-radio"
            value={SaltWide}
            checked={isSaltWide}
            onChange={onSelectPlayer(SaltWide)}
          />
          Standard
        </ItemLabel>
        {isFullResponsiveWide && (
          <ItemLabel>
            <CheckBox
              type="radio"
              name="course-player-radio"
              value={FullResponsiveWide}
              checked={isFullResponsiveWide}
              onChange={onSelectPlayer(FullResponsiveWide)}
            />
            Wide
          </ItemLabel>
        )}
        {(isSaltWide || isPercentageWide) && (
          <ItemLabel>
            <CheckBox
              type="radio"
              name="course-player-radio"
              checked={isPercentageWide}
              onChange={onPercentageInputCheck}
              value={percentage}
              min="50"
              max="100"
            />
            Wide
          </ItemLabel>
        )}
      </FormContainer>
    </>
  );
};

export default connect<IEditCoursePlayerState, IEditCoursePlayerDispatchProps, IEditCoursePlayerOwnProps>(
  (_: IState, ownProps: IEditCoursePlayerProps): IEditCoursePlayerState => {
    return {
      selected: ownProps.course.state.coursePlayer,
    };
  },
  (dispatch: Dispatch<IAction>, ownProps: IEditCoursePlayerProps) => ({
    selectCoursePlayer: (value: CoursePlayer) =>
      dispatch(
        Creators.patchCoursePlayer(
          ownProps.courseId,
          patchPayloadCreator(
            ownProps.course.versionId,
            modifyCoursePlayerPatch(ownProps.course, value, ownProps.userId)
          )
        )
      ),
  })
)(EditCoursePlayer);
